<template>
    <div class="slide container">
        <h2>Bad Wimsbach-Neydharting</h2>
        <div align="left">
            <p>
                Seit Herbst 2010 ist die Marktgemeinde Bad Wimsbach-Neydharting mit knapp 2.500 Einwohnerinnen und
                Einwohnern Klimabündnispartner und Energiespargemeinde. Seither arbeitet eine aktive Energiegruppe
                kontinuierlich, um den Menschen im Ort den Umweltschutz immer wieder in Erinnerung zu rufen. Diverse
                Aktionen fokussieren auf die unterschiedlichen Bereiche der Ressourcenschonung.
            </p>
            <p>
                Die Photovoltaik-Anlage auf
                dem Dach der neu errichteten Volksschule ist ein wichtiger Teil davon. Mit dem PV-Info-Point wird der
                Nutzen
                transparent.
            </p>
            <p>
                Als Tourismusgemeinde ist eine intakte Natur ein besonders hohes Gut!
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BwnSlide',
        components: {},
        props: {},
        methods: {},
    };
</script>

<style scoped>

</style>
